/** Artikel, Bestand, Lagerplätze, Wareneingang, Tagesabschluss, Produktion, Dashboard (Paket 1). */
import type { ProduktAbgleichErgebnis, Route } from '@storeos/contracts';
import { api, post } from '../api';
import { liste, patch, qs } from './http';
import type {
  ArtikelDetail, ArtikelZeile, Dashboard, Korrektur, Lagerplatz, Produktion, ProduktionScanErgebnis, StockLevel, Tagesabschluss,
  TagesabschlussErgebnis, WareneingangErgebnis,
} from './typen';

export const dashboard = () => api<Dashboard>('/dashboard');

export const artikelListe = (f: { q?: string; route?: string; nachbestellen?: string; on_demand_druck?: string; seite?: number; pro_seite?: number }) =>
  liste<ArtikelZeile>(`/artikel${qs(f)}`);
export const artikelDetail = (id: string) => api<ArtikelDetail>(`/artikel/${id}`);
export const artikelAendern = (id: string, d: {
  route?: Route; meldebestand?: number | null; standard_bin_id?: string | null; gewicht_g?: number | null;
  /** R110: Komponente (einstufige Stückliste); null entfernt sie. */ komponente_article_id?: string | null; komponente_menge?: number | null;
  /** R127: Modul wird bei B&B on demand gedruckt. */ on_demand_druck?: boolean;
}) => patch<unknown>(`/artikel/${id}`, d);
/** R109: interner Artikel (nur StoreOS, kein Kanal-Listing), Leitung/Admin. */
export const artikelAnlegen = (d: { sku?: string | null; name: string; gewicht_g?: number | null; bestand_fuehren?: boolean; standard_bin_id?: string | null; steuerklasse?: 'standard' | 'ermaessigt' }) =>
  post<{ id: string; sku: string }>('/artikel', d);
/** R102: Artikelstamm aus Woo übernehmen (Admin); danach Klärfälle „Artikel unbekannt“ neu prüfen. */
export const produkteAbgleichen = () => post<ProduktAbgleichErgebnis>('/integrationen/produkte/abgleich', {});
export const korrekturBuchen = (id: string, k: Korrektur) => post<StockLevel>(`/artikel/${id}/korrektur`, k);
export const lagerplaetze = () => liste<Lagerplatz>('/lagerplaetze');

export const wareneingang = (d: { article_id: string; menge: number; bin_id?: string | null }) =>
  post<WareneingangErgebnis>('/wareneingang', { positionen: [{ article_id: d.article_id, menge: d.menge, bin_id: d.bin_id ?? null }] });

export const tagesabschluss = () => api<Tagesabschluss>('/tagesabschluss');
/** `erwartet` = gezählte Pakete; Abweichung → 409, außer `force`. */
export const tagesabschlussBestaetigen = (erwartet: number, force = false) => post<TagesabschlussErgebnis>('/tagesabschluss', { erwartet, force });

export const produktion = () => api<Produktion>('/produktion');
export const produktionScan = (code: string) => post<ProduktionScanErgebnis>('/produktion/scan', { code });

/** R42: Partner-Sendungsnummern als CSV (kennung;tracking;carrier), Leitung. */
export const partnerCsvImport = (csv: string) => post<{ gemeldet: number; doppelt: number; fehler: Array<{ zeile: number; meldung: string }> }>('/partner/tracking/import', { csv });
